<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.inviteRelationship')"
    :batch-actions="batchActions"
    resource="invite_relationships"
  >
    <template slot="action">
      <bean-import-button
        can='students.create'
        buttonText="导入"
        tooltipText="导入推荐关系"
        url="/invite_relationships/import"
        loadingToast="导入中...请不要刷新页面"
        :excelTemplateDownloadLink="importExcelTemplateDownloadLink"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/invite_relationships.js';
import _ from 'lodash';

@Component
export default class InviteRelationships extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'phone',
      'parent',
      'user',
      'remark',
      type === 'show' && 'children',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array, { filterColumnsExtend })
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'phone',
      'parent_id',
      'user_id',
      'remark',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'invite_relationships.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'invite_relationships.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }

  get importExcelTemplateDownloadLink() {
    const baseUrl = process.env.BASE_URL;
    const fileName = '导入推荐关系';
    const url = baseUrl.endsWith('/') ? `${fileName}.xlsx` : `/${fileName}.xlsx`
    return baseUrl + url;
  }
}

export const route = [
  {
    path: '/invite_relationships',
    name: 'invite_relationships.index',
    component: InviteRelationships,
    props: {
      type: 'index',
    }
  },
  {
    path: '/invite_relationships/new',
    name: 'invite_relationships.new',
    component: InviteRelationships,
    props: {
      type: 'new',
    }
  },
  {
    path: '/invite_relationships/:id',
    name: 'invite_relationships.show',
    component: InviteRelationships,
    props: {
      type: 'show',
    }
  },
  {
    path: '/invite_relationships/:id/edit',
    name: 'invite_relationships.edit',
    component: InviteRelationships,
    props: {
      type: 'edit'
    }
  }
]
</script>
